module.exports = __webpack_public_path__ + "img/WarningStatus.b04d2cde.svg";